// The guided setup wizard's stages, derived from the quote's nav sections.
//
// Stage 1 is always the quantity. Then, PER priceable nav SECTION (e.g. Carton), a 'line' stage and a
// 'solution' stage -- one manufacturing line and one solution are chosen per section, never per sub_section.
// sectionIndex is the section's OWN position in navSections (the value every /mcc endpoint and the URL state key
// off), so the wizard, the address bar and the server all address the same section.
//
// TWO kinds of section are skipped, both because they have nothing to ask:
//   * the nav builder's 'general' catch-all, which is not a manufacturing part section;
//   * a LINKED section, which takes its manufacturing line and solution from another section (see
//     linkedNavSection.js). Walking someone through two stages that decide nothing would be worse than not
//     asking -- it would imply the answer is theirs to give.
//
// So the total is `1 + 2 * (number of sections that actually choose)`: a one-section Carton is 3 stages, and so
// is a carton_lamination + corrugated drawing, because only the lamination section chooses.
//
// linkedSectionIndexes is passed IN rather than read from the window here, so this stays a pure function the
// caller can test at any shape -- FrankSetupWizard reads the live sections and hands them over.
export const buildSetupWizardStages = (navSections, linkedSectionIndexes = []) => {
  const choosingSections = (navSections || [])
    .map((section, index) => ({ section, index }))
    .filter(({ section }) => section.part_type !== 'general')
    .filter(({ index }) => !linkedSectionIndexes.includes(index));

  return [
    { type: 'quantity' },
    ...choosingSections.flatMap(({ section, index }) => [
      { type: 'line', sectionIndex: index, label: section.label || section.part_type },
      { type: 'solution', sectionIndex: index, label: section.label || section.part_type },
    ]),
  ];
};

export default buildSetupWizardStages;
